namespace GeniuzPOS.Purchase {
    export class PoBankColumns {
        static columnsKey = 'Purchase.PoBank';
    }
}
